// client/src/hooks/useFranquiaPlan.js
import { useAuth } from '../context/auth/AuthProvider';

/**
 * Hook para acessar os recursos e limites do plano da franquia do usuário logado.
 */
export default function useFranquiaPlan() {
  const { user } = useAuth();
  const plan = user?.franquia?.plano || {};
  const features = plan?.features || {};
  
  /**
   * Verifica se um recurso booleano está disponível no plano.
   * @param {string} feature - Nome do recurso (ex: 'hasAgenda')
   * @returns {boolean}
   */
  const hasFeature = (feature) => {
    return features[feature] === true;
  };
  
  /**
   * Verifica o limite de uso de um recurso quantitativo.
   * @param {string} resource - Nome do recurso limitado (ex: 'limiteClientes')
   * @param {number} currentUsage - Quantidade atual utilizada
   * @returns {object} { isLimited: boolean, isUnlimited: boolean, remaining: number }
   */
  const checkLimit = (resource, currentUsage) => {
    const limitConfig = features[resource];
    
    // Se não há configuração de limite, é ilimitado.
    if (limitConfig === undefined || limitConfig === null) {
      return { isLimited: false, isUnlimited: true, remaining: Infinity };
    }
    
    // Para limites em formato de objeto (ex: { isUnlimited: true, value: 10 })
    if (typeof limitConfig === 'object') {
      if (limitConfig.isUnlimited) {
        return { isLimited: false, isUnlimited: true, remaining: Infinity };
      }
      
      const remaining = limitConfig.value - currentUsage;
      return {
        isLimited: remaining <= 0,
        isUnlimited: false,
        remaining: Math.max(0, remaining)
      };
    }
    
    // Para limites numéricos diretos (ex: 10 ou -1 para ilimitado)
    if (limitConfig === -1) {
      return { isLimited: false, isUnlimited: true, remaining: Infinity };
    }
    
    const remaining = limitConfig - currentUsage;
    return {
      isLimited: remaining <= 0,
      isUnlimited: false,
      remaining: Math.max(0, remaining)
    };
  };
  
  return {
    plan,
    hasFeature,
    checkLimit
  };
}
